import React, {Fragment} from 'react';
import { Link } from 'react-router-dom';
import CONFIG from '../../config';

export default {
    NEWS_LIST: [
        {
            timestamp: '2020-05-28',
            message: <Fragment>WikINM Facelift (v4)</Fragment>
        },
        {
            timestamp: '2017-04-04',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Jinxed'}>Jinxed</Link> wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2016-06-18',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#100.000 To Live Longer'}>100.000 To Live Longer</Link> wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2015-12-25',
            message: <Fragment>Das Weihnachtsvideo für das Jahr 2015 - <Link to={CONFIG.ROUTES.PROJECTS + '#Eine INM Weihnachtsgeschichte'}>Eine INM Weihnachtsgeschichte</Link> - wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2015-05-27',
            message: <Fragment><a href="https://www.youtube.com/watch?v=uPDQj2xvvTQ" target="_blank" rel="noopener noreferrer">Unser Beitrag zum Rockstar Editor Video-Contest</a> wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2013-12-20',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#The Dosshouse 3'}>The Dosshouse 3</Link> wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2013-11-06',
            message: <Fragment>WikINM Facelift - komplett neues Design wurde erstellt</Fragment>
        },
        {
            timestamp: '2012-12-25',
            message: <Fragment>Das Weihnachtsvideo für das Jahr 2012 - <Link to={CONFIG.ROUTES.PROJECTS + '#Christmas carols and stuff (Christmas 2012)'}>Christmas carols and stuff</Link> - wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2012-12-18',
            message: <Fragment>WikINM Update: Gästebucheinträge werden nun auf Seiten verteilt. Die Einträge pro Seite lassen sich anpassen.</Fragment>
        },
        {
            timestamp: '2012-12-15',
            message: <Fragment>WikINM ist wieder online, nachdem es vor 2 Wochen grundlos gesperrt wurde</Fragment>
        },
        {
            timestamp: '2012-10-26',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Aments of Bayside'}>Aments of Bayside</Link> wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2012-09-20',
            message: <Fragment>WikINM Update: Verlinkung zum Forum wurde hergestellt (Reiter "Forum")</Fragment>
        },
        {
            timestamp: '2012-09-13',
            message: <Fragment>WikINM Update: Sicherheitsabfragen im Gästebuch hinzugefügt</Fragment>
        },
        {
            timestamp: '2012-09-08',
            message: <Fragment>Beta Test vom Just Cause 2 Multiplayer (mit wesone)</Fragment>
        },
        {
            timestamp: '2012-09-07',
            message: <Fragment>WikINM Update: Der Reiter "Mehr von INM" wurde hinzugefügt</Fragment>
        },
        {
            timestamp: '2012-07-01',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#The Chase'}>The Chase</Link> wurde veröffentlicht ("Musikvideo" zu den Musiktiteln "Dark Chase" und "Chased Till Dawn")</Fragment>
        },
        {
            timestamp: '2012-04-07',
            message: <Fragment>Im Reiter "SAMP Server" gibt es nun eine Versionsgeschichte inkl. Patch Notes</Fragment>
        },
        {
            timestamp: '2012-03-16',
            message: <Fragment>WikINM Struktur wurde komplett umgeschrieben, ohne dass visuelle Neuerungen auftreten</Fragment>
        },
        {
            timestamp: '2012-02-10',
            message: <Fragment>INM veröffentlicht <a href="https://www.youtube.com/watch?v=hVVF3oYnqPo" target="_blank" rel="noopener noreferrer">Informationen zu ACTA (Anti-Counterfeiting Trade Agreement)</a></Fragment>
        },
        {
            timestamp: '2012-01-08',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Ice Cold Killers'}>Ice Cold Killers</Link> (das Ergebnis des INM Gewinnspiels) wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2012-01-07',
            message: <Fragment>GTA IV Machinima Test wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2011-12-25',
            message: <Fragment>Das Weihnachtsvideo für das Jahr 2011 - <Link to={CONFIG.ROUTES.PROJECTS + '#28 Hours Before Christmas (Christmas 2011)'}>28 Hours Before Christmas</Link> - wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2011-11-12',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Zed 2: Recommended Gateway'}>Zed 2: Recommended Gateway</Link> wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2011-09-28',
            message: <Fragment>WikINM Update: Im Reiter "SAMP Server" wurde eine Statusanzeige hinzugefügt, die anzeigt, ob der Server "online" oder "offline" ist</Fragment>
        },
        {
            timestamp: '2011-09-27',
            message: <Fragment>WikINM Update: Der Reiter "SAMP Server" wurde hinzugefügt</Fragment>
        },
        {
            timestamp: '2011-09-16',
            message: <Fragment>WikINM Update: Es ist nun möglich, sich für den Newsletter anzumelden</Fragment>
        },
        {
            timestamp: '2011-09-13',
            message: <Fragment>WikINM Update: Datum des letzten Besuchs wurde um Uhrzeit erweitert</Fragment>
        },
        {
            timestamp: '2011-08-11',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Rolling Dope 2'}>Rolling Dope 2</Link> wurde veröffentlicht</Fragment>
        },
        {
            timestamp: '2011-08-05',
            message: <Fragment>WikINM Update: Reihenfolge der Gästebucheinträge wurde geändert (thx Deadwood)</Fragment>
        },
        {
            timestamp: '2011-08-02',
            message: <Fragment>WikINM Update: Leuten wird das Datum des letzten Besuchs auf "Home" angezeigt</Fragment>
        },
        {
            timestamp: '2011-08-01',
            message: <Fragment>Nächstes Projekt: Rolling Dope 2</Fragment>
        },
        {
            timestamp: '2011-07-28',
            message: <Fragment><Link to={CONFIG.ROUTES.PROJECTS + '#Restless Survivors'}>Restless Survivors</Link> wurde beendet...</Fragment>
        },
        {
            timestamp: '2011-07-22',
            message: <Fragment>Es wird weiter an Restless Survivors IV gearbeitet...</Fragment>
        },
        {
            timestamp: '2011-03-20',
            message: <Fragment>WikINM wurde eröffnet...</Fragment>
        },
    ]
}
